import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import { getTenantHeaders } from '../config/tenant';
import type { ApiResponse } from '../types/api';
import type {
  QuizProgressStats,
  StudentProgressStats,
  VideoProgressStats,
} from '../types/statistics';

const authHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    ...getTenantHeaders(),
  };
};

export async function getStudentProgressStats(
  studentId: string
): Promise<StudentProgressStats | null> {
  try {
    const response = await axios.get<ApiResponse<StudentProgressStats>>(
      `${BASE_URL}api/Statistics/student/${studentId}`,
      { headers: authHeaders() }
    );
    if (response.data.success && response.data.data && typeof response.data.data === 'object') {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching student progress stats:', error);
    return null;
  }
}

export async function getStudentVideoProgress(
  studentId: string
): Promise<VideoProgressStats | null> {
  try {
    const response = await axios.get<ApiResponse<VideoProgressStats>>(
      `${BASE_URL}api/Student/GetStudentLessonsProgress/${studentId}`,
      { headers: authHeaders() }
    );
    if (response.data.success && response.data.data && typeof response.data.data === 'object') {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching video progress:', error);
    return null;
  }
}

export async function getStudentQuizProgress(
  studentId: string
): Promise<QuizProgressStats | null> {
  try {
    const response = await axios.get<ApiResponse<QuizProgressStats>>(
      `${BASE_URL}api/Student/GetStudentQuizzesProgress/${studentId}`,
      { headers: authHeaders() }
    );
    if (response.data.success && response.data.data && typeof response.data.data === 'object') {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching quiz progress:', error);
    return null;
  }
}
